import { render, staticRenderFns } from "./RfidFormModal.vue?vue&type=template&id=6e50769d"
import script from "./RfidFormModal.vue?vue&type=script&lang=js"
export * from "./RfidFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports